require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-tags-indiana-latino-institute.json") })
        }
      }, "path---es-articles-tags-indiana-latino-institute");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-tags-indiana-latino-institute!./.cache/json/es-articles-tags-indiana-latino-institute.json
// module id = 2357
// module chunks = 231608221292675